import { HttpRequest } from "util/http"


export interface INote {
  id: number
  message: string
  createTime: string
  reviewId: number
  client: string
  username: string
}

export const getNotes = (reviewId) => {
  const method = 'POST'
  const data = { reviewId }

  return HttpRequest.fetch<INote[]>('scripts/social_media/getNotes', { data, method }).then((review) => {
    return review
  })
}

export const addNote = (reviewId, message) => {
  const method = 'POST'
  const data = { reviewId, message }

  return HttpRequest.fetch<INote[]>('scripts/social_media/addNote', { data, method }).then((review) => {
    return review
  })
}

export const deleteNote = (noteId, reviewId) => {
  const method = 'POST'
  const data = { noteId, reviewId }

  return HttpRequest.fetch<INote[]>('scripts/social_media/deleteNote', { data, method }).then((review) => {
    return review
  })
}